import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/logo-footer.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const locations = [
  { key: 'LOC1', name: 'Broomfield'},
  { key: 'LOC2', name: 'Casper'},
  { key: 'LOC3', name: 'Cheyenne'},
  { key: 'LOC4', name: 'Colorado Springs'},
  { key: 'LOC5', name: 'Denver Tech Center'},
  { key: 'LOC6', name: 'Encinitas'},
  { key: 'LOC7', name: 'Erie'},
  { key: 'LOC8', name: 'Fort Collins'},
  { key: 'LOC9', name: 'Glendale-Cherry Creek'},
  { key: 'LOC10', name: 'Greeley'},
  { key: 'LOC11', name: 'Highlands Ranch'},
  { key: 'LOC12', name: 'La Jolla'},
  { key: 'LOC13', name: 'La Mesa'},
  { key: 'LOC14', name: 'Lakewood'},
  { key: 'LOC15', name: 'Lone Tree'},
  { key: 'LOC16', name: 'Longmont'},
  { key: 'LOC17', name: 'Loveland'},
  { key: 'LOC18', name: 'Mission Valley'},
  { key: 'LOC19', name: 'Norman, OK'},
  { key: 'LOC20', name: 'Northfield'},
  { key: 'LOC21', name: 'Oklahoma City, OK'},
  { key: 'LOC22', name: 'Riverfront-LoHi'},
  { key: 'LOC23', name: 'Roxborough'},
  { key: 'LOC24', name: 'Thornton'},
  { key: 'LOC25', name: 'Westminster'}
];

const locationApptLinks = locations.map((loc) => {
  const {
    [`REACT_APP_${loc.key}_APPT_LINK`]: locApptLink,
  } = process.env;
  return {
    name: loc.name,
    link: locApptLink,
    target: '_blank',
  };
});

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'smartyplans',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'smartyplansSubscriberToken',
  globalClass: 'smartyplans-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  heroLocaleColor: 'secondary',
  splitPlans: false,
  headerProps: {
    enable: true,
    showLogin: false,
    signupButtonFlow: 'login',
  },
  homeTemplateProps: {
    heroSection: {
      variant: 3,
      preTitleClasses: 'home-hero-pretitle',
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      showSubtitleDivider: true,
      primaryButtonProps: {
        scrollTo: 'pricing-benefit-section',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'primary',
      },
      heroImage: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      enable: true,
      variant: 1,
      definitionPosition: 'bottom',
    },
    membershipValueSection: {
      enable: true,
      variant: 1,
      position: 'top',
      heroImage: '/images/home-images/membership-value/membership-background-image.svg',
      heroImageAlt: 'SmartyPlan membership value preview',
      backgroundImages: [],
      arrowImages: {
        line: '/images/home-images/membership-value/arrow-line.svg',
      },
    },
    subscriptionSection: {
      priority: 'top',
      tabVariant: 2,
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
    },
    howItWorksSection: {
      enable: true,
      variant: 2,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.svg',
    },
    testimonialSection: {
      enable: false
    },
    staticHeroSection: {
      enable: false
    },
    contactSection: {
      enable: true
    },
    faqSection: {
      enable: true,
    }
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
    bookAppointmentProps: {
      target: '_blank',
      locationList: locationApptLinks,
    },
    secondaryButtonProps: {
      variant: 'outlined',
      color: 'primary',
    },
  },
  savingsSummary: {
     contactSection: 'contactDetails'
  },
  faqSection: {
    heroProps: {
      secondaryButtonProps: {
        variant:'outlined',
        color: "secondary"
      }
    }
  },
  dashboardProps: {
    showBenefitsUsage: false,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
    haveQuestionsPartnerLinks: {
      enable: false,
      prefix: 'Visit our partners',
      items: [
        {
          label: 'Audicus',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          label: 'United Vision Plan',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
    partnersSection: {
      enable: true,
      title: 'Access Your Benefits',
      pretitle: '',
      subtitle: '',
      items: [
        {
          icon: '/images/about/about-partners/about-partner-1.svg',
          iconAlt: 'Dental partner icon',
          link: 'https://www.teledentistry.com/smartyplan',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-2.svg',
          iconAlt: 'Hearing partner icon',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-3.svg',
          iconAlt: 'Vision partner icon',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
    enableFAQs: false,
  },
  aboutPage: {
    heroImage: '/images/about/about-hero.png',
    heroImageAlt: 'SmartyPlan monkey waving',
    primaryButtonProps: {
      to: '/savings-summary',
    },
    benefitsSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/about/about-benefits/about-benefits-1.svg',
          iconAlt: 'Simple membership icon',
        },
        {
          icon: '/images/about/about-benefits/about-benefits-2.svg',
          iconAlt: 'Dental hearing vision icon',
        },
        {
          icon: '/images/about/about-benefits/about-benefits-3.svg',
          iconAlt: 'Family friendly icon',
        },
        {
          icon: '/images/about/about-benefits/about-benefits-4.svg',
          iconAlt: 'Nationwide convenience icon',
        },
      ],
    },
    partnersSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/about/about-partners/about-partner-1.svg',
          iconAlt: 'Dental partner icon',
          link: 'https://www.teledentistry.com/smartyplan',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-2.svg',
          iconAlt: 'Hearing partner icon',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-3.svg',
          iconAlt: 'Vision partner icon',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
    howItWorksSection: {
      enable: true,
      variant: 1,
      image: '/images/home-images/how-it-works.svg',
      imageAlt: 'SmartyPlan member dashboard preview',
    },
    faqSection: {
      enable: true,
      variant: 1,
    },
    contactCardSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/contact-card/phone.svg',
          link: 'tel:(844)503-2400',
        },
        {
          icon: '/images/contact-card/mail.svg',
          link: 'mailto:care@subscribili.com',
        },
        {
          icon: '/images/contact-card/clock.svg',
        },
      ],
    },
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
